import * as ambassadorWixCaptcharatorV1CaptchaEntity from './captcharator-v1-captcha-entity-captcha.http.js';
import * as ambassadorWixCaptcharatorV1CaptchaEntityTypes from './captcharator-v1-captcha-entity-captcha.types.js';
import * as ambassadorWixCaptcharatorV1CaptchaEntityUniversalTypes from './captcharator-v1-captcha-entity-captcha.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function authorize(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCaptcharatorV1CaptchaEntityUniversalTypes.CaptchaRequest,
  ambassadorWixCaptcharatorV1CaptchaEntityTypes.CaptchaRequest,
  ambassadorWixCaptcharatorV1CaptchaEntityUniversalTypes.CaptchaResponse,
  ambassadorWixCaptcharatorV1CaptchaEntityTypes.CaptchaResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCaptcharatorV1CaptchaEntity.authorize(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/authorize',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CaptchaEntity as CaptchaEntityOriginal,
  CaptchaRequest as CaptchaRequestOriginal,
  CaptchaResponse as CaptchaResponseOriginal,
  Errors as ErrorsOriginal,
  AssessmentResponse as AssessmentResponseOriginal,
} from './captcharator-v1-captcha-entity-captcha.types.js';
